export default class Search {
  constructor() {
    this.searchOpen = document.querySelector("[data-search-icon]");
    if (!this.searchOpen) return false;
    this.searchBar = document.querySelector("[data-search-bar]");
    this.searchClose = document.querySelector("[data-search-close]");

    this.searchOpen.addEventListener("click", () => {
      this.searchBar.classList.add("open");
    });

    this.searchClose.addEventListener("click", () => {
      this.searchBar.classList.remove("open");
    });
  }
}
